import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19, _descriptor20;

function _createForOfIteratorHelper(o, allowArrayLike) {
  var it;

  if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;

      var F = function F() {};

      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }

    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }

  var normalCompletion = true,
      didErr = false,
      err;
  return {
    s: function s() {
      it = o[Symbol.iterator]();
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it["return"] != null) it["return"]();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

import { ORDER_TYPES } from "@dp/common";
import { action, computed, makeObservable, observable, runInAction } from "mobx";
import { ORDER_TYPE } from ".";
import BrandRules from "../../utils/BrandRules";
var CartModel = (_class = /*#__PURE__*/function () {
  // @observable private _currentAddToCartLoadingItemID: string = null;
  function CartModel(platformUtil) {
    var _this = this;

    _classCallCheck(this, CartModel);

    _initializerDefineProperty(this, "_restaurantDetail", _descriptor, this);

    _initializerDefineProperty(this, "_sessionDetails", _descriptor2, this);

    _initializerDefineProperty(this, "_cartItems", _descriptor3, this);

    _initializerDefineProperty(this, "_isCartEmptyMessageVisible", _descriptor4, this);

    _initializerDefineProperty(this, "_isOrderLimitReachedMessageVisible", _descriptor5, this);

    _initializerDefineProperty(this, "_isNotQualifiedDeliveryMessageVisible", _descriptor6, this);

    _initializerDefineProperty(this, "_isItemNotAddedToCartMessageVisible", _descriptor7, this);

    _initializerDefineProperty(this, "_isItemAddedToCartMessageVisible", _descriptor8, this);

    _initializerDefineProperty(this, "_currentItemAddedToCart", _descriptor9, this);

    _initializerDefineProperty(this, "_cart", _descriptor10, this);

    _initializerDefineProperty(this, "_appAttributes", _descriptor11, this);

    _initializerDefineProperty(this, "_isGiftCardPresentMessageVisible", _descriptor12, this);

    _initializerDefineProperty(this, "_isCheckoutLoading", _descriptor13, this);

    _initializerDefineProperty(this, "_isAddToCartLoading", _descriptor14, this);

    _initializerDefineProperty(this, "_showEditMenuCustomizationModal", _descriptor15, this);

    _initializerDefineProperty(this, "_showSmartRecommendationMenuListModal", _descriptor16, this);

    _initializerDefineProperty(this, "_isOrderTypeGiftCard", _descriptor17, this);

    _initializerDefineProperty(this, "_cartComponentLoader", _descriptor18, this);

    _initializerDefineProperty(this, "_orderTypeValue", _descriptor19, this);

    _initializerDefineProperty(this, "_cartContainerLoader", _descriptor20, this);

    _defineProperty(this, "setCartEmptyMessageVisibility", function (modalState) {
      console.log("setCartEmptyMessageVisibility");
      runInAction(function () {
        _this._isCartEmptyMessageVisible = modalState;
      });
    });

    _defineProperty(this, "setOrderLimitReachedMessageVisibility", function (modalState) {
      runInAction(function () {
        _this._isOrderLimitReachedMessageVisible = modalState;
      });
    });

    _defineProperty(this, "setItemNotAddedToCartMessageVisibility", function (modalState) {
      runInAction(function () {
        _this._isItemNotAddedToCartMessageVisible = modalState;
      });
    });

    _defineProperty(this, "setItemAddedToCartMessageVisibility", function (modalState) {
      runInAction(function () {
        _this._isItemAddedToCartMessageVisible = modalState;
      });
    });

    _defineProperty(this, "setNotQualifiedDeliveryMessageVisibility", function (modalState) {
      runInAction(function () {
        _this._isNotQualifiedDeliveryMessageVisible = modalState;
      });
    });

    _defineProperty(this, "setGiftCardPresentMessageVisibility", function (modalState) {
      runInAction(function () {
        _this._isGiftCardPresentMessageVisible = modalState;
      });
    });

    this._cartItems = [];
    makeObservable(this);
  }

  _createClass(CartModel, [{
    key: "toggleCartContainerLoader",
    value: function toggleCartContainerLoader(show) {
      this._cartContainerLoader = show;
    }
  }, {
    key: "setOrderTypeValue",
    value: function setOrderTypeValue(order) {
      this._orderTypeValue = order === null || order === void 0 ? void 0 : order.orderType;
    }
  }, {
    key: "toggleCartComponentLoader",
    value: function toggleCartComponentLoader(show) {
      this._cartComponentLoader = show;
    }
  }, {
    key: "toggleSmartRecommendationMenuListModal",
    value: function toggleSmartRecommendationMenuListModal(show) {
      var _this2 = this;

      runInAction(function () {
        _this2._showSmartRecommendationMenuListModal = show;
      });
    }
  }, {
    key: "toggleEditMenuCustomizationModal",
    value: function toggleEditMenuCustomizationModal(show) {
      var _this3 = this;

      runInAction(function () {
        _this3._showEditMenuCustomizationModal = show;
      });
    }
  }, {
    key: "setAppAttributesData",
    value: function setAppAttributesData(_appAttributes) {
      var _this4 = this;

      runInAction(function () {
        _this4._appAttributes = _appAttributes;
      });
    }
  }, {
    key: "setIsCheckoutLoading",
    value: function setIsCheckoutLoading(bool) {
      this._isCheckoutLoading = bool;
    }
  }, {
    key: "setIsAddToCartLoading",
    value: function setIsAddToCartLoading(bool) {
      this._isAddToCartLoading = bool;
    }
  }, {
    key: "setSessionDetails",
    value: function setSessionDetails(_sessionDetails) {
      var _this5 = this;

      runInAction(function () {
        _this5._sessionDetails = _sessionDetails;
      });
    }
  }, {
    key: "setRestaurantDetailData",
    value: function setRestaurantDetailData(restaurantDetail) {
      var _this6 = this;

      runInAction(function () {
        _this6._restaurantDetail = restaurantDetail;
      });
    }
  }, {
    key: "setCartData",
    value: function setCartData(_cart) {
      var _this7 = this;

      runInAction(function () {
        _this7._cart = _cart;
      });
    }
  }, {
    key: "setCurrentItemAddedToCart",
    value: function setCurrentItemAddedToCart(cartItem) {
      var _this8 = this;

      runInAction(function () {
        _this8._currentItemAddedToCart = cartItem;
      });
    }
  }, {
    key: "setRestaurantData",
    value: function setRestaurantData(restDetail) {
      var _this9 = this;

      runInAction(function () {
        _this9._restaurantDetail = restDetail;
      });
    }
  }, {
    key: "getImageUrl",
    value: function getImageUrl(url) {
      if (url === null || !url) {
        if (this._appAttributes.concept.conceptCode === "LH") {
          return this._appAttributes.configs.mediaRoot_menulistingimage_url;
        } else {
          return this._appAttributes.configs.mediaRoot_stoneimage_url;
        }
      }

      return url;
    }
  }, {
    key: "getCartItemsFromCommerceItems",
    value: function getCartItemsFromCommerceItems(commerceItems) {
      var _this10 = this;

      if (commerceItems && commerceItems.length) {
        return commerceItems.map(function (item) {
          var _item$priceInfo, _item$productRef, _item$productRef2, _item$productRef3;

          return {
            id: item.id,
            productId: item.productId,
            skuId: item.catalogRefId,
            menuTitle: item.displayName,
            price: (item === null || item === void 0 ? void 0 : (_item$priceInfo = item.priceInfo) === null || _item$priceInfo === void 0 ? void 0 : _item$priceInfo.amount) + "",
            imageUrl: _this10.getImageUrl(item !== null && item !== void 0 && (_item$productRef = item.productRef) !== null && _item$productRef !== void 0 && _item$productRef.largeImageUrl ? item === null || item === void 0 ? void 0 : (_item$productRef2 = item.productRef) === null || _item$productRef2 === void 0 ? void 0 : _item$productRef2.largeImageUrl : item === null || item === void 0 ? void 0 : (_item$productRef3 = item.productRef) === null || _item$productRef3 === void 0 ? void 0 : _item$productRef3.largeImage),
            quantity: item.quantity,
            breadCount: item.quantity * item.breadCount,
            label: item.guestName,
            specialInstructions: item.itemInstructions,
            itemCourse: item === null || item === void 0 ? void 0 : item.itemCourse,
            defaultCourse: item === null || item === void 0 ? void 0 : item.defaultCourse,
            alternateCourse: item === null || item === void 0 ? void 0 : item.alternateCourse,
            selectedProperties: _this10._getSelectedPropertiesForDisplay(item.subItem)
          };
        });
      } else {
        return [];
      }
    } // public addToCart(cartItem: ICartItem): void {
    //   console.log("Added to cart");
    //   runInAction(() => {
    //     this._cartItems.push(cartItem);
    //     this._currentItemAddedToCart = cartItem;
    //     this.setItemAddedToCartMessageVisibility(true);
    //     setTimeout(() => {
    //       this.setItemAddedToCartMessageVisibility(false);
    //     }, 3000);
    //   });
    // }

  }, {
    key: "_getSelectedPropertiesForDisplay",
    value: function _getSelectedPropertiesForDisplay(subItems) {
      var selectedProperties = [];
      var currentProperty = null;

      if (subItems) {
        var _iterator = _createForOfIteratorHelper(subItems),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var subItem = _step.value;

            if (subItem.optionType) {
              var _this$_appAttributes;

              var newOptionName = new BrandRules((_this$_appAttributes = this._appAttributes) === null || _this$_appAttributes === void 0 ? void 0 : _this$_appAttributes.currentConceptCode).cartCustomizationName(subItem.configOptionName || subItem.description, subItem.optionType);

              if (currentProperty) {
                currentProperty.options.push({
                  name: newOptionName,
                  id: subItem.selectedId,
                  price: subItem.unitPrice
                });
              } else {
                currentProperty = {
                  id: subItem.productId,
                  name: "",
                  catalogRefId: subItem.catalogRefId,
                  selectedId: subItem.selectedId,
                  configurablePropertyId: subItem.configurablePropertyId,
                  options: [{
                    name: newOptionName,
                    id: subItem.selectedId,
                    price: subItem.unitPrice
                  }]
                };
                selectedProperties.push(currentProperty);
                currentProperty = null;
              }
            } else {
              var _this$_appAttributes2;

              var _newOptionName = new BrandRules((_this$_appAttributes2 = this._appAttributes) === null || _this$_appAttributes2 === void 0 ? void 0 : _this$_appAttributes2.currentConceptCode).cartCustomizationName(subItem.configOptionName || subItem.skuDisplayName, subItem.optionType);

              currentProperty = {
                id: subItem.productId,
                name: subItem.displayName,
                catalogRefId: subItem.catalogRefId,
                selectedId: subItem.selectedId,
                configurablePropertyId: subItem.configurablePropertyId,
                options: [{
                  name: _newOptionName,
                  id: subItem.selectedId,
                  price: subItem.unitPrice
                }]
              };
              selectedProperties.push(currentProperty);
              currentProperty = null;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      /*const formattedSubItems = subItems?.map((subItem: CartTypes.SubItem) => {
        const newOptionName = new BrandRules(
          this._appAttributes?.currentConceptCode,
        ).cartCustomizationName(subItem.skuDisplayName, subItem.optionType);
         return {
          id: subItem.productId,
          name: subItem.displayName,
          catalogRefId: subItem.catalogRefId,
          selectedId: subItem.selectedId,
          configurablePropertyId: subItem.configurablePropertyId,
          options: [
            {
              name: newOptionName,
              id: subItem.selectedId,
              price: subItem.unitPrice,
            },
          ],
        };
      });
      formattedSubItems.forEach((subItem) => {
        const existing = selectedProperties.filter(function (item) {
          return item.configurablePropertyId === subItem.configurablePropertyId;
        });
        if (existing.length) {
          const existingIndex = selectedProperties.indexOf(existing[0]);
          selectedProperties[existingIndex].options = selectedProperties[
            existingIndex
          ].options.concat(subItem.options);
        } else {
          selectedProperties.push(subItem);
        }
      });*/


      return selectedProperties;
    }
  }, {
    key: "setIsOrderTypeGiftCard",
    value: function setIsOrderTypeGiftCard(bool) {
      this._isOrderTypeGiftCard = bool;
    }
  }, {
    key: "carteItemTotalQuantity",
    value: function carteItemTotalQuantity(items) {
      var total = 0;
      items.forEach(function (_c) {
        total = total + _c.quantity;
      });
      return total;
    }
  }, {
    key: "orderId",
    get: function get() {
      var _this$_cart;

      return (_this$_cart = this._cart) === null || _this$_cart === void 0 ? void 0 : _this$_cart.orderId;
    }
  }, {
    key: "showCartContainerLoader",
    get: function get() {
      return !!this._cartContainerLoader;
    }
  }, {
    key: "orderType",
    get: function get() {
      var _this$_sessionDetails, _this$_sessionDetails2, _this$_sessionDetails3;

      return this._orderTypeValue || ((_this$_sessionDetails = this._sessionDetails) === null || _this$_sessionDetails === void 0 ? void 0 : (_this$_sessionDetails2 = _this$_sessionDetails.successResponse) === null || _this$_sessionDetails2 === void 0 ? void 0 : (_this$_sessionDetails3 = _this$_sessionDetails2.sessionContext) === null || _this$_sessionDetails3 === void 0 ? void 0 : _this$_sessionDetails3.orderTypeValue);
    }
  }, {
    key: "showCartComponentLoader",
    get: function get() {
      return !!this._cartComponentLoader;
    }
  }, {
    key: "showSmartRecommendationMenuListModal",
    get: function get() {
      return !!this._showSmartRecommendationMenuListModal;
    }
  }, {
    key: "showEditMenuCustomizationModal",
    get: function get() {
      return !!this._showEditMenuCustomizationModal;
    }
  }, {
    key: "isCheckoutLoading",
    get: function get() {
      return this._isCheckoutLoading;
    }
  }, {
    key: "isAddToCartLoading",
    get: function get() {
      return this._isAddToCartLoading;
    } // @action setCurrentAddToCartLoadingItemID(id) {
    //   this._currentAddToCartLoadingItemID = id;
    // }
    // @computed get currentAddToCartLoadingItemID() {
    //   return this._currentAddToCartLoadingItemID;
    // }

  }, {
    key: "emptyCartOrderOnlineUrl",
    get: function get() {
      var _this$_appAttributes3, _this$_appAttributes4;

      return (_this$_appAttributes3 = this._appAttributes) === null || _this$_appAttributes3 === void 0 ? void 0 : (_this$_appAttributes4 = _this$_appAttributes3.configs) === null || _this$_appAttributes4 === void 0 ? void 0 : _this$_appAttributes4.emptyCartOrderOnlineUrl;
    }
  }, {
    key: "emptyCartSwitchGiftCardsUrl",
    get: function get() {
      var _this$_appAttributes5, _this$_appAttributes6;

      return (_this$_appAttributes5 = this._appAttributes) === null || _this$_appAttributes5 === void 0 ? void 0 : (_this$_appAttributes6 = _this$_appAttributes5.configs) === null || _this$_appAttributes6 === void 0 ? void 0 : _this$_appAttributes6.emptyCartSwitchGiftCardsUrl;
    }
  }, {
    key: "isCheckoutEnabled",
    get: function get() {
      if (this.orderType === ORDER_TYPES.CATERING_DELIVERY && this.totalCartAmount > this.maxDeliveryAmmount) {
        return false;
      } // if (
      //   this.orderType === ORDER_TYPES.TOGO_PICKUP &&
      //   this.totalCartAmount > this.maxPickupAmmount
      // )
      //   return false;
      // if (
      //   this.orderType === ORDER_TYPES.CATERING_PICKUP &&
      //   this.totalCartAmount > this.maxCateringPickupAmmount
      // )
      //   return false;


      return true;
    }
  }, {
    key: "maxCateringPickupAmmount",
    get: function get() {
      var _this$_sessionDetails4, _this$_sessionDetails5;

      return ((_this$_sessionDetails4 = this._sessionDetails) === null || _this$_sessionDetails4 === void 0 ? void 0 : (_this$_sessionDetails5 = _this$_sessionDetails4.successResponse) === null || _this$_sessionDetails5 === void 0 ? void 0 : _this$_sessionDetails5.cateringPickupOrderAmountThreshold) || 0;
    }
  }, {
    key: "minPickupAmmount",
    get: function get() {
      return 0;
    }
  }, {
    key: "maxPickupAmmount",
    get: function get() {
      var _this$_sessionDetails6, _this$_sessionDetails7;

      return ((_this$_sessionDetails6 = this._sessionDetails) === null || _this$_sessionDetails6 === void 0 ? void 0 : (_this$_sessionDetails7 = _this$_sessionDetails6.successResponse) === null || _this$_sessionDetails7 === void 0 ? void 0 : _this$_sessionDetails7.orderAmountThreshold) || 0;
    }
  }, {
    key: "minDeliveryAmmount",
    get: function get() {
      var _this$_sessionDetails8, _this$_sessionDetails9;

      return ((_this$_sessionDetails8 = this._sessionDetails) === null || _this$_sessionDetails8 === void 0 ? void 0 : (_this$_sessionDetails9 = _this$_sessionDetails8.successResponse) === null || _this$_sessionDetails9 === void 0 ? void 0 : _this$_sessionDetails9.cateringDeliveryMinOrderAmountThreshold) || 0;
    }
  }, {
    key: "maxDeliveryAmmount",
    get: function get() {
      var _this$_sessionDetails10, _this$_sessionDetails11;

      return ((_this$_sessionDetails10 = this._sessionDetails) === null || _this$_sessionDetails10 === void 0 ? void 0 : (_this$_sessionDetails11 = _this$_sessionDetails10.successResponse) === null || _this$_sessionDetails11 === void 0 ? void 0 : _this$_sessionDetails11.cateringDeliveryOrderAmountThreshold) || 0;
    }
  }, {
    key: "deliveryOrderCartHeaderMessage",
    get: function get() {
      if (this.orderType === ORDER_TYPES.CATERING_DELIVERY) {
        var _this$_cart2, _this$_cart2$commerce;

        var minAmmount = this.minDeliveryAmmount;

        if ((_this$_cart2 = this._cart) !== null && _this$_cart2 !== void 0 && (_this$_cart2$commerce = _this$_cart2.commerceItems) !== null && _this$_cart2$commerce !== void 0 && _this$_cart2$commerce.length) {
          if (minAmmount > this.totalCartAmount) {
            var ammout = minAmmount - this.totalCartAmount;
            return "$".concat(ammout.toFixed(2), " of items needed to qualify for delivery");
          } else {
            return "Your order qualifies for delivery";
          }
        }
      }

      return null;
    }
  }, {
    key: "isOrderQualifiedForCateringDelivery",
    get: function get() {
      if (this.orderType === ORDER_TYPES.CATERING_DELIVERY) {
        var _this$_cart3, _this$_cart3$commerce;

        var minAmmount = this.minDeliveryAmmount;

        if ((_this$_cart3 = this._cart) !== null && _this$_cart3 !== void 0 && (_this$_cart3$commerce = _this$_cart3.commerceItems) !== null && _this$_cart3$commerce !== void 0 && _this$_cart3$commerce.length) {
          return minAmmount <= this.totalCartAmount;
        }
      }

      return false;
    }
  }, {
    key: "deliveryCartMessage",
    get: function get() {
      // orderType === 2
      if (this.orderType === ORDER_TYPES.CATERING_DELIVERY) {
        var _this$_cart4, _this$_cart4$commerce;

        var minAmmount = this.minDeliveryAmmount;
        if (!((_this$_cart4 = this._cart) !== null && _this$_cart4 !== void 0 && (_this$_cart4$commerce = _this$_cart4.commerceItems) !== null && _this$_cart4$commerce !== void 0 && _this$_cart4$commerce.length)) return "Minimum of $".concat(minAmmount, " of items needed to qualify for delivery. 10% delivery fee of upto $500, then $5 for every dollar thereafter");
      }

      return null;
    }
  }, {
    key: "isCartEmptyMessageVisible",
    get: function get() {
      return this._isCartEmptyMessageVisible;
    }
  }, {
    key: "isOrderLimitReachedMessageVisible",
    get: function get() {
      return this._isOrderLimitReachedMessageVisible;
    }
  }, {
    key: "isItemNotAddedToCartMessageVisible",
    get: function get() {
      return this._isItemNotAddedToCartMessageVisible;
    }
  }, {
    key: "isItemAddedToCartMessageVisible",
    get: function get() {
      return this._isItemAddedToCartMessageVisible;
    }
  }, {
    key: "isNotQualifiedDeliveryMessageVisible",
    get: function get() {
      return this._isNotQualifiedDeliveryMessageVisible;
    }
  }, {
    key: "isGiftCardPresentMessageVisible",
    get: function get() {
      return this._isGiftCardPresentMessageVisible;
    }
  }, {
    key: "currentItemAddedToCart",
    get: function get() {
      var _this$_currentItemAdd;

      return (_this$_currentItemAdd = this._currentItemAddedToCart) === null || _this$_currentItemAdd === void 0 ? void 0 : _this$_currentItemAdd.map(function (item) {
        var _item$productRef4, _item$productRef5;

        return {
          imageUrl: item === null || item === void 0 ? void 0 : (_item$productRef4 = item.productRef) === null || _item$productRef4 === void 0 ? void 0 : _item$productRef4.largeImageUrl,
          menuTitle: item === null || item === void 0 ? void 0 : (_item$productRef5 = item.productRef) === null || _item$productRef5 === void 0 ? void 0 : _item$productRef5.displayName,
          quantity: item === null || item === void 0 ? void 0 : item.quantity
        };
      });
    }
  }, {
    key: "cartItems",
    get: function get() {
      var _this$_cart5;

      return this.getCartItemsFromCommerceItems((_this$_cart5 = this._cart) === null || _this$_cart5 === void 0 ? void 0 : _this$_cart5.commerceItems);
    }
  }, {
    key: "isOrderTypeGiftCard",
    get: function get() {
      return this._isOrderTypeGiftCard;
    }
  }, {
    key: "noOfCartItems",
    get: function get() {
      var _this$_cart6;

      if (this.orderType === ORDER_TYPES.GIFT_CARD) {
        var _this$_sessionDetails12, _this$_sessionDetails13, _this$_sessionDetails14;

        this.setIsOrderTypeGiftCard(true);
        return (_this$_sessionDetails12 = this._sessionDetails) === null || _this$_sessionDetails12 === void 0 ? void 0 : (_this$_sessionDetails13 = _this$_sessionDetails12.successResponse) === null || _this$_sessionDetails13 === void 0 ? void 0 : (_this$_sessionDetails14 = _this$_sessionDetails13.sessionContext) === null || _this$_sessionDetails14 === void 0 ? void 0 : _this$_sessionDetails14.itemCount;
      }

      return this.carteItemTotalQuantity(((_this$_cart6 = this._cart) === null || _this$_cart6 === void 0 ? void 0 : _this$_cart6.commerceItems) || []);
    }
  }, {
    key: "totalCartAmount",
    get: function get() {
      var _this$_cart7; //TO CONFIRM
      // return this._cart?.commerceItems?.reduce(
      //   (amount, item) => item.priceInfo.amount + amount,
      //   0,
      // );


      return Number((_this$_cart7 = this._cart) === null || _this$_cart7 === void 0 ? void 0 : _this$_cart7.subTotalWithoutItemDiscount);
    }
  }, {
    key: "_maxThresholdOrderAmount",
    get: function get() {
      if (this.orderType === ORDER_TYPES.TOGO_PICKUP) {
        var _this$_sessionDetails15, _this$_sessionDetails16;

        return (_this$_sessionDetails15 = this._sessionDetails) === null || _this$_sessionDetails15 === void 0 ? void 0 : (_this$_sessionDetails16 = _this$_sessionDetails15.successResponse) === null || _this$_sessionDetails16 === void 0 ? void 0 : _this$_sessionDetails16.orderAmountThreshold;
      } else if (this.orderType === ORDER_TYPES.CATERING_PICKUP) {
        var _this$_sessionDetails17, _this$_sessionDetails18;

        return (_this$_sessionDetails17 = this._sessionDetails) === null || _this$_sessionDetails17 === void 0 ? void 0 : (_this$_sessionDetails18 = _this$_sessionDetails17.successResponse) === null || _this$_sessionDetails18 === void 0 ? void 0 : _this$_sessionDetails18.cateringPickupOrderAmountThreshold;
      } else if (this.orderType === ORDER_TYPES.CATERING_DELIVERY) {
        var _this$_restaurantDeta;

        return (_this$_restaurantDeta = this._restaurantDetail) === null || _this$_restaurantDeta === void 0 ? void 0 : _this$_restaurantDeta.catDeliveryMaxOrderAmount;
      } else if (this.orderType === ORDER_TYPE.ORDER_AHEAD) {
        var _this$_sessionDetails19, _this$_sessionDetails20;

        return (_this$_sessionDetails19 = this._sessionDetails) === null || _this$_sessionDetails19 === void 0 ? void 0 : (_this$_sessionDetails20 = _this$_sessionDetails19.successResponse) === null || _this$_sessionDetails20 === void 0 ? void 0 : _this$_sessionDetails20.orderAheadOrderAmountThreshold;
      }

      return null;
    }
  }, {
    key: "catertingDeliveryOrderDeliveryFee",
    get: function get() {
      var _this$_cart8;

      return ((_this$_cart8 = this._cart) === null || _this$_cart8 === void 0 ? void 0 : _this$_cart8.deliveryFee) || 0;
    }
  }, {
    key: "cateringDeliverycostPerPerson",
    get: function get() {
      var _this$_cart9;

      return ((_this$_cart9 = this._cart) === null || _this$_cart9 === void 0 ? void 0 : _this$_cart9.costPerPerson) || 0;
    }
  }, {
    key: "checkoutButtonDisplayAmount",
    get: function get() {
      return this.orderType === ORDER_TYPES.CATERING_DELIVERY ? this.cateringDeliveryOrderTotalAmmountIncludingDeliveryFee : this.totalCartAmount;
    }
  }, {
    key: "cateringDeliveryOrderTotalAmmountIncludingDeliveryFee",
    get: function get() {
      var _this$_cart10, _this$_cart10$priceIn;

      return ((_this$_cart10 = this._cart) === null || _this$_cart10 === void 0 ? void 0 : (_this$_cart10$priceIn = _this$_cart10.priceInfo) === null || _this$_cart10$priceIn === void 0 ? void 0 : _this$_cart10$priceIn.total) || 0;
    }
  }, {
    key: "maximumNumberOfGuests",
    get: function get() {
      var _this$_appAttributes7, _this$_appAttributes8, _this$_appAttributes9, _this$_appAttributes10;

      return (_this$_appAttributes7 = this._appAttributes) !== null && _this$_appAttributes7 !== void 0 && (_this$_appAttributes8 = _this$_appAttributes7.configs) !== null && _this$_appAttributes8 !== void 0 && _this$_appAttributes8.maximumNumberOfGuests ? Number((_this$_appAttributes9 = this._appAttributes) === null || _this$_appAttributes9 === void 0 ? void 0 : (_this$_appAttributes10 = _this$_appAttributes9.configs) === null || _this$_appAttributes10 === void 0 ? void 0 : _this$_appAttributes10.maximumNumberOfGuests) : 99;
    }
  }, {
    key: "courseOptionsType",
    get: function get() {
      var _this$_appAttributes11;

      return (_this$_appAttributes11 = this._appAttributes) === null || _this$_appAttributes11 === void 0 ? void 0 : _this$_appAttributes11.courseOptions;
    }
  }]);

  return CartModel;
}(), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "_restaurantDetail", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "_sessionDetails", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "_cartItems", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "_isCartEmptyMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "_isOrderLimitReachedMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "_isNotQualifiedDeliveryMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_isItemNotAddedToCartMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "_isItemAddedToCartMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "_currentItemAddedToCart", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "_cart", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "_appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "_isGiftCardPresentMessageVisible", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "_isCheckoutLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "_isAddToCartLoading", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "_showEditMenuCustomizationModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class.prototype, "_showSmartRecommendationMenuListModal", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor17 = _applyDecoratedDescriptor(_class.prototype, "_isOrderTypeGiftCard", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor18 = _applyDecoratedDescriptor(_class.prototype, "_cartComponentLoader", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class.prototype, "_orderTypeValue", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor20 = _applyDecoratedDescriptor(_class.prototype, "_cartContainerLoader", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "toggleCartContainerLoader", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCartContainerLoader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderId", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderId"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCartContainerLoader", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCartContainerLoader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setOrderTypeValue", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setOrderTypeValue"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "orderType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "orderType"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showCartComponentLoader", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showCartComponentLoader"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showSmartRecommendationMenuListModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showSmartRecommendationMenuListModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "showEditMenuCustomizationModal", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "showEditMenuCustomizationModal"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsCheckoutLoading", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsCheckoutLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckoutLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckoutLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsAddToCartLoading", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsAddToCartLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isAddToCartLoading", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isAddToCartLoading"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emptyCartOrderOnlineUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "emptyCartOrderOnlineUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "emptyCartSwitchGiftCardsUrl", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "emptyCartSwitchGiftCardsUrl"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCheckoutEnabled", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCheckoutEnabled"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxCateringPickupAmmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxCateringPickupAmmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minPickupAmmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "minPickupAmmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxPickupAmmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxPickupAmmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "minDeliveryAmmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "minDeliveryAmmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maxDeliveryAmmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maxDeliveryAmmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryOrderCartHeaderMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryOrderCartHeaderMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderQualifiedForCateringDelivery", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderQualifiedForCateringDelivery"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryCartMessage", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryCartMessage"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isCartEmptyMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCartEmptyMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderLimitReachedMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderLimitReachedMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isItemNotAddedToCartMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isItemNotAddedToCartMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isItemAddedToCartMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isItemAddedToCartMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isNotQualifiedDeliveryMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isNotQualifiedDeliveryMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isGiftCardPresentMessageVisible", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isGiftCardPresentMessageVisible"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "currentItemAddedToCart", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "currentItemAddedToCart"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cartItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cartItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setIsOrderTypeGiftCard", [action], Object.getOwnPropertyDescriptor(_class.prototype, "setIsOrderTypeGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderTypeGiftCard", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderTypeGiftCard"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "noOfCartItems", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "noOfCartItems"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "totalCartAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "totalCartAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "_maxThresholdOrderAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "_maxThresholdOrderAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "catertingDeliveryOrderDeliveryFee", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "catertingDeliveryOrderDeliveryFee"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cateringDeliverycostPerPerson", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cateringDeliverycostPerPerson"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkoutButtonDisplayAmount", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkoutButtonDisplayAmount"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cateringDeliveryOrderTotalAmmountIncludingDeliveryFee", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "cateringDeliveryOrderTotalAmmountIncludingDeliveryFee"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "maximumNumberOfGuests", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "maximumNumberOfGuests"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "courseOptionsType", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "courseOptionsType"), _class.prototype)), _class);
export { CartModel as default };